<template>
  <div
    class="bg-black bg-center bg-no-repeat bg-cover rounded image-container"
    :style="{ backgroundImage: url ? `url(${url})` : '' }"
    @click="$emit('click')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'UtilImgBackground',
  props: {
    url: { type: String }
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.image-container::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: spin 1s linear infinite;
  z-index: 10;
  display: none;
}

.image-container:not([style*='background-image'])::before {
  display: block; /* Show spinner if no background image */
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>
